import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import TopicCard from "@/components/base/TopicCard";
import { topics } from "@/mocks/topics";

export default function FeaturedTopics() {
  const featured = topics.slice(0, 6);
  return (
    <section className="mx-auto max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="精选专题目录"
        title="按主题整理好的热门合集"
        desc="每个专题都按时间顺序排好看点，从话题起点一路读到结尾，不用来回跳转。"
        action={
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部合集
            <i className="ri-arrow-right-line text-base" />
          </Link>
        }
      />
      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {featured.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}